<script>
import { UnraidLoading } from '@unraid/shared-components';

export default {
  name: 'SuccessTile',
  components: {
    UnraidLoading,
  },
  props: {
    success: Boolean,
    title: String,
    loading: Boolean,
  },
  computed: {
    icon() {
      return this.success ? '&check;' : '&times;';
    },
  },
};
</script>
<template>
  <div
    class="text-left flex flex-row items-center max-w-2xs mt-4 px-6 py-4 mx-auto border rounded-sm shadow"
    :class="{
      'bg-white border-grey-lighter dark:bg-black dark:border-grey-dark': success,
      'text-white bg-red border border-red': !success,
    }"
  >
    <span v-if="loading" class="flex-none inline-flex items-center w-8 h-8">
      <UnraidLoading :height="18" />
    </span>
    <span
      v-else
      v-html="icon"
      class="text-2xl font-semibold inline-flex items-center justify-center rounded-full w-8 h-8 p-2"
      :class="{
        'text-white bg-gradient-to-r from-red to-orange': success,
        'text-red bg-white': !success }"></span>
    <span class="ml-4">
      {{ title }}
    </span>
  </div>
</template>
